<template>
  <div class="mb-5">
    <div class="py-3 px-4 text-center text-uppercase font-weight-bold text-primary bg-light border">
      {{title}}
    </div>

    <div
      v-for="item in data"
      :key="item.id"
      class="border-right border-left">
      <div class="py-3 px-4 border-bottom bg-light font-weight-bold text-primary">
        {{item.name}}
      </div>

      <div
        v-for="prescription in item.prescriptions"
        :key="prescription.id"
        class="border-bottom">
        <div class="row">
          <div class="col-6 py-2">
            <div class="pl-4 text-nowrap">
              {{prescription.drug.name}}
              {{prescription.drug.measure}}
              {{prescription.drug.measureUnit}}

              <small class="text-muted">
                {{prescription.drug.manufacturer ? prescription.drug.manufacturer.name : ''}}
              </small>
            </div>

            <div class="pl-4 text-nowrap text-muted">
              <small>
                {{ prescription.quantity }}
                {{declineNumber(prescription.quantity, prescription.drug.format.name)}}
              </small>

              <small>
                {{ prescription.times.map(time => time.name).join(', ') }};
                {{ prescription.methods.map(method => method.name).join(', ') }}
              </small>
            </div>
          </div>

          <div class="col-6">
            <div class="row">
              <div class="col-4 py-2 border-left">
                <div>
                  {{prescription.duration}}
                  {{declineNumber(prescription.duration, 'день')}}
                </div>

                <div class="text-nowrap text-muted">
                  <small>
                    {{formatDate(prescription.startDate, 'd.m.y')}} -
                    {{formatDate(prescription.finishDate, 'd.m.y')}}
                  </small>
                </div>
              </div>

              <div class="col-3 border-left">
                <div
                  v-if="prescription.startedAt"
                  class="text-nowrap py-2">
                  <div class="text-success">
                    начат

                    <small>
                      {{formatDate(prescription.startedAt, 'd.m.y')}}
                    </small>
                  </div>
                </div>

                <div
                  v-else
                  class="text-warning text-center py-3">
                  не начат
                </div>
              </div>

              <div class="col-5 py-3 border-left">
                {{prescription.author ? prescription.author.lastname : ''}}
                {{prescription.author ? prescription.author.firstname : ''}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';
import declineNumber from '../../../utils/declineNumber';
import {FORMAT_NAMES} from '../../../constants';

export default {
  name: 'ClientDrugList',

  props: ['title', 'prescriptions'],

  computed: {
    data() {
      const data = {};

      for(const prescription of this.prescriptions) {
        const key = prescription.drug.ingredient.catalog.id;

        if (typeof data[key] === 'undefined') {
          data[key] = {
            id: prescription.drug.ingredient.catalog.id,
            name: prescription.drug.ingredient.catalog.name,
            prescriptions: [],
          };
        }

        data[key].prescriptions.push(prescription);
      }

      return data;
    },
  },

  methods: {
    formatDate(date, format) {
      return formatDate(date, format);
    },

    declineNumber(count, name) {
      const formatName = FORMAT_NAMES.find(item => item[0] === name);
      const [, few, one, two ] = formatName || [name, name, name, name];

      return declineNumber(count, few, one, two);
    },
  },
};
</script>
